import { createSlice } from "@reduxjs/toolkit";

import {getIndividualReservedLessons,
} from "redux/actions/studentLessons";
import {IReservationIndividualReservedLesson} from "../../types/redux/reservation";

export interface IReservationIndividualReserved {
    reservationIndividualReserved: IReservationIndividualReservedLesson[]|null;
    loading:boolean
}

const initial: IReservationIndividualReserved = {
    reservationIndividualReserved:null,
    loading:false
};

export const reservationIndividualReservedSlice = createSlice({
    name: "reservationIndividualReservedSlice",
    initialState: initial,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getIndividualReservedLessons.pending, (state, action) => {
            state.loading= true;
        });
        builder.addCase(getIndividualReservedLessons.fulfilled, (state, action) => {
            state.loading = false;
            state.reservationIndividualReserved = action.payload;
        });
        builder.addCase(getIndividualReservedLessons.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export const {} = reservationIndividualReservedSlice.actions;

export default reservationIndividualReservedSlice.reducer;
